/**
 * @param {object} gallery
 */
export const photoswipePreviews = gallery => {
    let added = false;
    const props = {
        gallery,
        selector: '[data-previews]'
    };
    gallery.listen('gettingData', () => {
        if (added) return;
        added = true;
        addPreviews(props);
    });
    gallery.listen('close', () => {
        removePreviews(props);
    });
    gallery.listen('afterChange', () => {
        setActivePreview(props);
    });
};

/**
 * @typedef photoSwipePreviewsMethodProps
 * @prop {object} gallery
 * @prop {string} selector
 */

/**
 * @param {photoSwipePreviewsMethodProps} props
 */
const addPreviews = ({ gallery, selector }) => {
    const { scrollWrap, items } = gallery;
    const place = scrollWrap.querySelector(selector);
    if (items && items.length > 1) {
        scrollWrap.classList.add('pswp__with-previews');
        for (const item of items) {
            let element;
            if (!item.type || item.type === 'image') {
                const { msrc: preview } = item;
                element = document.createElement('img');
                element.setAttribute('src', preview);
            } else if (item.type === 'video') {
                element = document.createElement('figure');
                element.classList.add('video-thumbnail');
            }

            element.id = `${item.id}-preview-element`;
            element.classList.add('preview-element');
            element.addEventListener('click', () => {
                gallery.goTo(items.indexOf(item));
            });
            place.appendChild(element);
        }
    } else {
        scrollWrap.classList.remove('pswp__with-previews');
    }
};

/**
 * @param {photoSwipePreviewsMethodProps} props
 */
const removePreviews = ({ gallery, selector }) => {
    const { scrollWrap } = gallery;
    const place = scrollWrap.querySelector(selector);
    place.innerHTML = '';
};

/**
 * @param {photoSwipePreviewsMethodProps} props
 */
const setActivePreview = ({ gallery, selector }) => {
    const { scrollWrap, currItem } = gallery;
    const { id } = currItem;
    const place = scrollWrap.querySelector(selector);
    const previewElements = place.querySelectorAll('.preview-element');
    for (const element of previewElements) {
        const className = 'is-active';
        if (element.id === `${id}-preview-element`) {
            element.classList.add(className);
            element.scrollIntoView({ behavior: 'smooth' });
        } else {
            element.classList.remove(className);
        }
    }
};
